import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch, FaChalkboardTeacher, FaRegCalendarAlt, FaChild } from "react-icons/fa";
import { IoLibraryOutline } from "react-icons/io5";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { FaTasks } from "react-icons/fa";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonSmall,ButtonWhite} from '../../components/buttons';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import '../../styling/calendar.css';
import { UserContext } from '../../context/UserContext';
import { ClockLoader } from 'react-spinners';
import { RouteDisplay } from '../../components/route_display';
import ProgressBarComponent from '../../components/progess_bar';
import { SetClassLinkModal } from '../../components/set_class_link';
import { SiGoogleclassroom } from 'react-icons/si';

// type ValuePiece = Date | null;

// type Value = ValuePiece | [ValuePiece, ValuePiece];

function DashboardScreen() {
  const navigate = useNavigate();
  const [value, onChange] = useState(new Date());
//   const [calendarValues, setCalendarValues] = useState([]);
  const [loadingClasses, setLoadingClasses] = useState(false);
  const [loadingTasks, setLoadingTasks] = useState(false);
  const [cookies] = useCookies();
  const [enrolledClasses, setEnrolledClasses] = useState([]);
  const [tasks, setTasks] = useState([]);
  const { setTostMessage } = useContext(TostMessageContext);
  const {logOutFunction, calendarValues, setCalendarValues, userProfile} = useContext(UserContext);
  const [joiningRoom, setJoiningRoom] = useState(false);
  const [setClassLink, showSetClassLink] = useState(false);
  const [classLinkDets, setClassLinkDets] = useState({})

  useEffect(() => {
    getClasses();
  }, []);

    function isSameDay(date1, date2) {
        return (
            new Date(date1).getFullYear() === date2.getFullYear() &&
            new Date(date1).getMonth() === date2.getMonth() &&
            new Date(date1).getDate() === date2.getDate()
        );
    }


  const getClasses = async () => {
    setLoadingClasses(true);
    try {
        const response = await axios.get(base_url + '/classes/fetch_enrolled_classes.php', {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                main_id: cookies?.userProfile?.main_id,
                sub_id: cookies?.userProfile?.sub_id
            },
        });
        if (response.data.code == 403) {
            setLoadingClasses(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
            logOutFunction()
        }
        if (response.data.status) {
            setLoadingClasses(false);
            if (response.data.results?.length > 0) {
                setEnrolledClasses(response.data.results);
                setCalendarValues(response.data.calendar);
            }
            if (response.data.tasks?.length > 0) {
                setTasks(response.data.tasks);
            }
        } else {
            setLoadingClasses(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
        }
    } catch (error) {
        setLoadingClasses(false);
        setTostMessage({
            messageType: "error",
            message: 'Network error',
        });
    }
  }

  const joinClassroom = async (schedule_id, group_id, category, language_id, level_id) => {
    const formData = new FormData();
    if (category == 'GROUP') {
        formData.append('class_group', group_id)
        formData.append('schedule_id', schedule_id)
        formData.append('category', category);
    } else {
        formData.append('category', category);
        formData.append('language_id', language_id);
        formData.append('level_id', level_id);
        formData.append('schedule_id', schedule_id);
    }

    setJoiningRoom(true);
    console.log(schedule_id, group_id)
    try {
        const response = await axios.post(base_url + '/classes/join-class.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                main_id: cookies?.userProfile?.main_id,
                sub_id: cookies?.userProfile?.sub_id
            },
        });
        if (response.data.code == 403) {
            setJoiningRoom(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
            logOutFunction()
        }
        if (response.data.status) {
            setJoiningRoom(false);
            if (response.data) {
                if (response.data.meeting_link != "") {
                    window.open(response.data.meeting_link, '_blank');
                } else {
                    setTostMessage({
                        messageType: "error",
                        message: 'Room link not set, please wait',
                    });
                }
            }
        } else {
            setJoiningRoom(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
        }
    } catch (error) {
        setJoiningRoom(false);
        setTostMessage({
            messageType: "error",
            message: 'Network error',
        });
    }
  }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                {setClassLink && (
                    <SetClassLinkModal 
                        schedule_id={classLinkDets?.schedule_id} 
                        category={classLinkDets?.category}
                        language_name={classLinkDets?.language}
                        level_name={classLinkDets?.level_name}
                        showSetClassLink={showSetClassLink}
                    />
                )}
                {joiningRoom && (
                    <div className='flex justify-center items-center w-fill-available h-full z-[999999] bg-[#ffffff] opacity-[0.6] fixed top-0'>
                        <div className='flex flex-col justify-center items-center w-[200px] h-[200px] rounded-[10px] bg-[#241D0C]'>
                            <a className='text-yellow text-lg font-bold mb-3'>Joining Room</a>
                            <ClockLoader
                                color={'#F4D00F'}
                                loading={joiningRoom}
                                size={60}
                                aria-label="Loading Spinner"
                                data-testid="loader1"
                            />
                        </div>
                    </div>
                )}
                <div className='flex flex-col lg:flex-row justify-between'>
                    <div className='w-full lg:w-[70%] flex flex-col'>
                        {/* Hero Card */}
                        <div className="bg-gradient-to-r from-dark to-yellow text-white p-6 rounded-xl mb-6">
                            <h3 className="text-lg font-semibold mb-2">You're shaping the future, one lesson at a time</h3>
                            <p className="mb-4">Your dedication is helping learners connect with their culture and language roots. We're here to support you every step of the way—let's make every session impactful.</p>
                        </div>
                        <div className='w-full min-h-[250px] flex flex-col'>
                            <div className="flex justify-between mb-2">
                                <div className='flex flex-row items-center'>
                                    <IoLibraryOutline />
                                    <h4 className="text-sm ml-2 font-medium text-gray-700">Upcoming Classes</h4>
                                </div>
                                <a href="/my-classes" className="text-blue-600 text-sm">View all</a>
                            </div>
                            {loadingClasses ? (
                                <div className='w-max flex justify-center items-center mx-auto my-auto'>
                                    <ClockLoader
                                        color={'#212121'}
                                        loading={loadingClasses}
                                        size={25}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                    />
                                </div>
                            ) : (
                            <>
                            {!loadingClasses && enrolledClasses?.length < 1 ? ( 
                                <div className='mx-auto my-auto flex flex-col items-center justify-center'>
                                    <div className="text-gray-400 text-sm">You have not been assigned any classes</div>
                                    <div className='flex flex-row mt-5 justify-center'>
                                        <ButtonSmall loading={false} onPress={() => null} label={'Contact Admin'} />
                                    </div>
                                </div>
                            ) : (
                                <div className="flex flex-wrap lg:flex-nowrap justify-between lg:justify-start gap-x-2 lg:gap-x-6 py-2 overflow-x-auto">
                                    {enrolledClasses?.map((cls, index) => (
                                        <div
                                        key={index}
                                        className={`w-[47%] lg:w-60 min-w-[47%] mb-2 lg:mb-0 lg:min-w-[15rem] rounded-[10px] ${cls.theme.background} p-4 space-y-2`}
                                        >
                                        <h3 className="text-[13px] lg:text-[16px] font-semibold text-dark">{cls.language}</h3>

                                        {cls.category == "GROUP" && <div className="flex items-center gap-2 text-sm text-gray-700">
                                            <FaChild />
                                            <span>{cls.age_group} years</span>
                                        </div>}

                                        {cls.category == "PRIVATE" && <div className="flex items-center gap-2 text-sm text-gray-700">
                                            <FaChild />
                                            <span>{cls.child_name}</span>
                                        </div>}

                                        <div className="flex items-center gap-2 text-sm text-gray-700">
                                            <SiGoogleclassroom />
                                            <span>{cls.category == "GROUP" ? cls.max_no : '1 of 1'} enrolled</span>
                                        </div>

                                        <div className="flex items-center gap-2 text-sm text-gray-700">
                                            <FaRegCalendarAlt />
                                            <span>{cls.next_class == "" ? 'Not Set' : cls.next_class}</span>
                                        </div>
                                        <div className='mt-1 lg:mt-4 w-full flex justify-start'>
                                            {!cls.subscription_sts ? (
                                                <button className=" bg-[#00b47a] cursor-pointer text-white font-regular py-2 px-4 rounded-md">
                                                    Renew
                                                </button>
                                            ) : (
                                            <>
                                            {cls.meeting_link == "" && (
                                                <button onClick={() => {setClassLinkDets({ 'schedule_id': cls.schedule_id, 'category': cls.category, 'language': cls.language, 'level': cls.level_name }); showSetClassLink(true)}} className="bg-[#12B2FF] cursor-pointer text-white font-regular py-2 px-4 rounded-md">
                                                    Set Class Link
                                                </button>
                                            )}
                                            {(cls.meeting_link !== "" && cls.type == "LIVE") && (
                                                <button onClick={() => joinClassroom(cls.schedule_id, cls.group_id, cls.category, cls.language_id, cls.level_id)} className="bg-yellow cursor-pointer text-black font-bold py-2 px-4 rounded-md">
                                                    Join class
                                                </button>
                                            )}
                                            {(cls.meeting_link !== "" && cls.type !== "LIVE") && (
                                                <button onClick={() => joinClassroom(cls.schedule_id, cls.group_id, cls.category, cls.language_id, cls.level_id)} className="bg-yellow cursor-pointer text-black font-bold py-2 px-4 rounded-md">
                                                    Watch Video
                                                </button>
                                            )}
                                            </>
                                            )}
                                        </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                            </>
                            )}
                        </div>
                        <div className='w-full min-h-[100px] lg:min-h-[250px] mb-4 lg:mb-0 flex flex-col'>
                            <div className="flex justify-between mb-2">
                                <div className='flex flex-row items-center'>
                                    <FaTasks />
                                    <h4 className="text-sm ml-2 font-medium text-gray-700">Tasks & Homework</h4>
                                </div>
                                <a href="/assigned-classes" className="text-blue-600 text-sm">View all</a>
                            </div>
                            {loadingClasses ? (
                                <div className='w-max flex justify-center items-center mx-auto my-auto'>
                                    <ClockLoader
                                        color={'#212121'}
                                        loading={loadingClasses}
                                        size={25}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                    />
                                </div>
                            ) : (
                            <>
                            {tasks?.length < 1 && (
                                <div className='mx-auto my-auto'>
                                    <div className="text-gray-400 text-sm mx-auto">No tasks yet…</div>
                                </div>
                            )}
                            </>
                            )}
                            {tasks?.length > 0 && (
                                <div className='w-full mt-3'>
                                    {tasks?.map((task, index) => 
                                        <div className='w-full mb-2 rounded-[10px] bg-[#F7F7F9] py-2 px-4 flex justify-between items-center'>
                                            <a>{task.task_title} - {task.language}</a>
                                            <div className='p-1 px-3 bg-[#DFFEE7] text-[13px] font-semibold text-[#15C077] rounded-[5px]'>Due: {task.due_date}</div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    {/* Calendar */}
                    <div className='w-full lg:w-[25%]'>
                        <div className="bg-white p-4 rounded-xl shadow-3xl-blue">
                            <h4 className="text-sm text-gray-700 mb-2">Preview</h4>
                            <hr />
                            <div className="text-sm mt-4 text-gray-600">
                                <Calendar  
                                    prevLabel="‹"
                                    nextLabel="›" 
                                    selectRange={false}
                                    tileClassName={({ date }) =>
                                        calendarValues.some(d => isSameDay(d, date)) ? 'booked' : null
                                    }
                                    next2Label={null}
                                    prev2Label={null}
                                    // tileClassName={'highlight-green'}
                                    // onChange={onChange} 
                                    value={value} 
                                />
                            </div>
                        </div>
                        <div className="bg-white p-4 mt-3 rounded-xl shadow-3xl-blue">
                            <h4 className="text-sm text-gray-700 mb-2">Attendance</h4>
                            <hr />
                            <div className="text-sm mt-4 text-gray-600">
                                <ProgressBarComponent percentage={cookies?.userProfile?.attendance || 0} />
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
  );
}

export default DashboardScreen;
